import { store } from '@/app/store';
import { useSelector, shallowEqual } from 'react-redux';

export const useUserInfo = userId => useSelector(state => state.userInfoData.users[userId]);

export const getUserNickName = userId => store.getState().userInfoData.users[userId]?.nickName;
export const useUserNickName = userId => useSelector(() => getUserNickName(userId));

export const getUserImage = userId => store.getState().userInfoData.users[userId]?.image;
export const useUserImage = userId => useSelector(() => getUserImage(userId));

export const useIsBlockedByMe = userId => useSelector(state => state?.userInfoData?.users[userId]?.isBlockedByMe);
export const useIsBlockedMe = userId => useSelector(state => state?.userInfoData?.users[userId]?.isBlockedMe);

export const getIsBlockedByMe = userId => store.getState()?.userInfoData?.users[userId]?.isBlockedByMe;
export const getIsBlockedMe = userId => store.getState()?.userInfoData?.users[userId]?.isBlockedMe;
export const getMuteStatus = userId => (store.getState()?.userInfoData?.users[userId]?.isMuted ? 1 : 0);

export const selectUserDetails = (state, userId, keys) => {
   const user = state?.userInfoData?.users[userId];
   if (!user) return {};
   if (!keys || !Array.isArray(keys) || keys.length === 0) return user;

   return keys.reduce((acc, key) => {
      acc[key] = user[key];
      return acc;
   }, {});
};

export const getUserDetails = (userId, keys) => selectUserDetails(store.getState(), userId, keys);

export const useUserDetails = (userId, keys) =>
   useSelector(state => selectUserDetails(state, userId, keys), shallowEqual) || {};

export const useIsUserDeleted = userId => useSelector(state => state?.userInfoData?.users[userId]?.isDeleted);
